import React from 'react'
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { openPopup } from '../../../store/popupSlice';

export default function OnDemandFriendly() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="zip-need-area">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-6">
              <div className="zip-img">
                <img src="/assets/home/ondemand-friendly.webp" alt="on demand" className="img-responsive" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="zip-need-head">
                <h2 className="heading">User Friendly & Easy-to- Use On Demand Apps</h2>
                <p>Our on-demand apps are designed with simplicity and efficiency at the core, ensuring users of all technical skill levels can navigate effortlessly. From quick sign-ups to smooth ordering and real-time tracking, every feature is built to deliver an intuitive experience that saves time and effort.</p>
                <p>With a clean interface and responsive design, our apps ensure hassle-free usage on any device, whether smartphone, tablet, or desktop. We prioritize user satisfaction by making it easy to connect customers with services instantly, reliably, and at scale.</p>
                <div className="col-lg-12"><div className="clone-app-left"><Link onClick={() => dispatch(openPopup())} className="default-btn">Book a demo</Link></div></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}



